
<div class="grid grid-cols-1 space-y-4 select-none" *ngIf="dataSource">
  <div *ngIf="showBigBanner"
    class="w-full !overflow-y-hidden md:col-span-2 banner-slider transition-all rounded-[24px] overflow-hidden relative">
    <ng-container *ngIf="resetSwiper()">

      <a [href]="dataSource?.Section?.Data?.Slider[0].Url" class="w-full !h-fit">
        <img class="h-[416px] md:h-[467px] w-full object-cover rounded-[24px]" id="slider-pic-banner"
          [ngSrc]="dataSource?.Section?.Data?.Slider[0].PictureUrl" height="467" width="832" [loading]="'eager'"
          [alt]="" />
        <div
          class="flex flex-col items-start justify-start lg:justify-start p-3 md:p-10 absolute top-0 lg:bottom-5 lg:top-5 lg:right-0 text-white leading-10 lg:leading-[60px] w-full h-full space-y-3 lg:space-y-8">
          <div class="p-2 space-y-[11.7px]">
            <p class="font-bold text-xl md:text-2xl lg:text-5xl lg:mr-20">
              {{ dataSource?.Section?.Data?.Slider[0].PictureName.split('&988&')[0] }}
            </p>
            <p class="text-sm md:text-md lg:text-2xl lg:mr-20 lg:!font-[500] font-medium space-x-1">
              {{ dataSource?.Section?.Data?.Slider[0].PictureName.split('&988&')[1] }}
            </p>
            <button
              class="h-8 lg:h-10 flex justify-between space-x-3 items-center bg-white hover:bg-slate-100 rounded-[41px] p-2 lg:px-6 lg:p-2 text-xs lg:text-xl font-medium lg:font-semibold text-black lg:mr-20">
              <span class="flex justify-between items-center">
                اطلاعات بیشتر
                <i class="ico ico-Left !text-xl font-medium lg:font-semibold"></i>
              </span>
            </button>
          </div>
        </div>
      </a>
    </ng-container>
  </div>


  <div class="w-full flex justify-between gap-4 md:gap-4 md:col-span-1 rounded-[24px] !h-[220px] lg:!h-[350px]">

    <swiper [config]="secondaryBannersConfig">
      <ng-template swiperSlide>
        <a [href]="accommodation() === 'ecolodge' ? dataSource?.top?.Url : dataSource?.Section?.Data?.BottomUrl" target="_blank" class="!h-full block rounded-[24px]">
          <img [ngSrc]="accommodation() === 'ecolodge' ? dataSource?.top?.PictureUrl : dataSource?.Section?.Data?.BottomBanner?.Default?.Url" id="slider-pic-banner-1"
            class="lg:h-[331px] h-[190px] cursor-pointer rounded-[24px] object-cover w-full" height="331" width="586"
            alt="تخفیف های خاص ایران هتل، نظرات واقعی" />
        </a>
      </ng-template>

      <ng-template swiperSlide>
        <a [href]="accommodation() === 'ecolodge' ? dataSource?.bottom?.Url : dataSource?.Section?.Data?.TopUrl" target="_blank" class="!h-full block">
          <img [ngSrc]="accommodation() === 'ecolodge' ? dataSource?.bottom?.PictureUrl : dataSource?.Section?.Data?.TopBanner?.Default?.Url" id="slider-pic-banner-2"
            class="lg:h-[331px] h-[190px] cursor-pointer rounded-[24px] object-cover w-full" height="331" width="586"
            alt="تخفیف های خاص ایران هتل، نظرات واقعی" />
        </a>
      </ng-template>
    </swiper>
  </div>
</div>